import { terrainVectorTileConfig } from "./display-layers/terrainVectorTiles";

export const vectorTileRegistry = {
  ...terrainVectorTileConfig,
};